"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  fab: ({
    theme
  }) => ({
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary
  }),
  staticTooltipLabel: ({
    theme
  }) => ({
    backgroundColor: 'transparent',
    boxShadow: 'unset',
    color: theme.palette.common.white,
    fontWeight: 'bold',
    padding: '4px 12px'
  }),
  tooltipPlacementLeft: {
    '& .MuiSpeedDialAction-staticTooltipLabel': {
      marginRight: 0
    }
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiSpeedDialAction.js.map